import React from 'react';

const TermsConditions = () => {
  return (
    <div className="policy-page">
      <div className="container">
        

        <div className="row">
          <div className="col-lg-12 mx-auto">
            <div className="policy-content">
              <h3>Terms and Conditions</h3>
              <p>Welcome to IBRLIVE.COM. These Terms and Conditions govern your use of our website and services. By accessing our website and using our services, you agree to comply with these terms. If you do not agree with any part of these terms, you should not use our services.</p>
              
              <h4>1. Definitions</h4>
              <p><strong>1.1.</strong> "Service" refers to the currency exchange services provided by ibrlive.com through our website ibrlive.com.</p>
              <p><strong>1.2.</strong> "User" refers to any individual or entity who accesses our website or uses our services.</p>
              <p><strong>1.3.</strong> "Transaction" refers to the act of buying or selling currency through our platform.</p>
              
              <h4>2. Use of Services</h4>
              <p><strong>2.1.</strong> To use our services, you must be at least 18 years old and have the legal capacity to enter into binding agreements.</p>
              <p><strong>2.2.</strong> You agree to provide accurate and complete information when creating an account and using our services.</p>
              <p><strong>2.3.</strong> You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>
              
              <h4>3. Currency Exchange Rates</h4>
              <p><strong>3.1.</strong> The exchange rates displayed on our website are indicative rates and may change without notice. The final rate for a transaction will be determined at the time of confirmation.</p>
              <p><strong>3.2.</strong> We do not guarantee the availability of any particular exchange rate at any given time.</p>
              
              <h4>4. Transactions and Orders</h4>
              <p><strong>4.1.</strong> All transactions are subject to acceptance by ibrlive.com. We reserve the right to refuse or cancel any transaction at our discretion.</p>
              <p><strong>4.2.</strong> Once a transaction has been confirmed, it cannot be modified or canceled by the user. Any requests for changes or cancellations will be handled in accordance with our Refund and Cancellation Policy.</p>
              <p><strong>4.3.</strong> We may require additional verification or information before accepting any transaction.</p>
              
              <h4>5. Fees and Charges</h4>
              <p><strong>5.1.</strong> Fees for our services will be displayed on our website. By using our services, you agree to pay any applicable fees.</p>
              <p><strong>5.2.</strong> We reserve the right to change our fees at any time. Any fee changes will be effective immediately upon being posted on our website.</p>
              
              <h4>6. Limitation of Liability</h4>
              <p><strong>6.1.</strong> IBRLIVE will not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of our services.</p>
              <p><strong>6.2.</strong> We do not guarantee the accuracy, completeness, or timeliness of information provided on our website.</p>
              
              <h4>7. Compliance with Laws</h4>
              <p><strong>7.1.</strong> You agree to comply with all applicable laws, regulations, and rules regarding your use of our services.</p>
              <p><strong>7.2.</strong> You agree not to use our services for any illegal or unauthorized purpose, including but not limited to money laundering, fraud, or other illegal activities.</p>
              
              <h4>8. Termination</h4>
              <p><strong>8.1.</strong> We may terminate or suspend your access to our services at any time, without prior notice or liability, for any reason, including but not limited to a breach of these Terms.</p>
              <p><strong>8.2.</strong> Upon termination, your right to use our services will immediately cease.</p>
              
              <h4>9. Governing Law</h4>
              <p><strong>9.1.</strong> These Terms and Conditions are governed by and construed in accordance with the laws of your Jurisdiction.</p>
              <p><strong>9.2.</strong> Any disputes arising from these Terms and Conditions will be subject to the exclusive jurisdiction of the courts of your Jurisdiction.</p>
              
              <h4>10. Changes to Terms and Conditions</h4>
              <p><strong>10.1.</strong> We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon being posted on our website.</p>
              <p><strong>10.2.</strong> It is your responsibility to review these Terms periodically. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.</p>
              
              <h4>11. Contact Us</h4>
              <p><strong>11.1.</strong> If you have any questions about these Terms and Conditions, please contact us at <strong>contact@ibrlive.com</strong>.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .policy-page {
          padding: 80px 0 0 0;
          min-height: 80vh;
        }
        
        .page-header {
          margin-bottom: 50px;
        }
        
        .page-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 15px;
        }
        
        .page-header p {
          font-size: 1.1rem;
          color: #666;
        }
        
        .policy-content {
          background: white;
          padding: 40px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .policy-content h3 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #333;
          margin: 25px 0 20px 0;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .policy-content h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #555;
          margin: 25px 0 15px 0;
        }
        
        .policy-content p {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 20px;
        }
        
        .policy-content ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        
        .policy-content li {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 8px;
        }
        
        .policy-content strong {
          color: #333;
          font-weight: 600;
        }
        
        @media (max-width: 768px) {
          .policy-content {
            padding: 20px;
          }
          
          .page-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsConditions;
